export type RouteConfig = {
  onChange: (path: string) => void
}

/**
 * Very small history-based router: listens to popstate and exposes navigate().
 * Keeps logic minimal to mirror the watson-director style.
 */
export class MiniRouter {
  private onChange: (path: string) => void

  constructor(config: RouteConfig) {
    this.onChange = config.onChange
    window.addEventListener("popstate", this.handlePopState)
  }

  dispose() {
    window.removeEventListener("popstate", this.handlePopState)
  }

  navigate(path: string) {
    if (window.location.pathname === path) return
    window.history.pushState({}, "", path)
    this.onChange(path)
  }

  private handlePopState = () => {
    this.onChange(window.location.pathname)
  }
}
